export default __webpack_public_path__ + "static/media/section-header-2.1ab77f7c.jpg";